export default __webpack_public_path__ + "static/fertilefallhome1-bca23ec6acf31fcbc6006596b18c9165.png";